import { Pipe, PipeTransform } from '@angular/core';
import { ColumnDefinition } from 'src/app/models/server/column-definition';
import { FolderDocument } from 'src/app/models/server/folder-document';

@Pipe({
    name: 'avmDocumentCellPipe',
    standalone: true,
    pure: true,
})
export class AvmDocumentCellPipe implements PipeTransform {
    constructor() {}

    /**
     * Formate une cellule de la liste des documents.
     * @param document : Instance du document affiché par la ligne contenant la cellule.
     * @param columnDefinition : Définition de la colonne affichant la cellule
     */
    transform(document: FolderDocument, columnDefinition: ColumnDefinition): string {
        //console.count(`AvmDocumentCellPipe - transform ${document.id} - ${columnDefinition.header}`);

        if (!!document[columnDefinition.propertyCode]) {
            return `${document[columnDefinition.propertyCode]}`;
        } else {
            return '';
        }
    }
}
